export { default } from './TableBody';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableBody/index.js
// module id = 562
// module chunks = 2